var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCrowdenergy270(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99.2 99.2",
    style: {
      enableBackground: "new 0 0 99.2 99.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "podklad"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M89.6,4c3.1,0,5.6,2.5,5.6,5.6v80c0,3.1-2.5,5.6-5.6,5.6h-80c-3.1,0-5.6-2.5-5.6-5.6v-80C4,6.5,6.5,4,9.6,4 H89.6 M89.6,0h-80C4.3,0,0,4.3,0,9.6v80c0,5.3,4.3,9.6,9.6,9.6h80c5.3,0,9.6-4.3,9.6-9.6v-80C99.2,4.3,94.9,0,89.6,0L89.6,0z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "svg5673"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M38.7,58.1c4.1,0,7.5,3.4,7.5,7.5s-3.4,7.5-7.5,7.5c-4.1,0-7.5-3.4-7.5-7.5S34.6,58.1,38.7,58.1 M38.7,55.1 c-5.8,0-10.5,4.7-10.5,10.5c0,5.8,4.7,10.5,10.5,10.5s10.5-4.7,10.5-10.5C49.2,59.8,44.5,55.1,38.7,55.1L38.7,55.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M60.6,58.1c4.1,0,7.5,3.4,7.5,7.5s-3.4,7.5-7.5,7.5c-4.1,0-7.5-3.4-7.5-7.5S56.4,58.1,60.6,58.1 M60.6,55.1 c-5.8,0-10.5,4.7-10.5,10.5c0,5.8,4.7,10.5,10.5,10.5c5.8,0,10.5-4.7,10.5-10.5C71.1,59.8,66.4,55.1,60.6,55.1L60.6,55.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M38.7,28.1c2.3,0,4.1,1.8,4.1,4.1s-1.8,4.1-4.1,4.1s-4.1-1.8-4.1-4.1S36.5,28.1,38.7,28.1 M38.7,25.1 c-3.9,0-7.1,3.2-7.1,7.1s3.2,7.1,7.1,7.1c3.9,0,7.1-3.2,7.1-7.1S42.7,25.1,38.7,25.1L38.7,25.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M60.6,28.1c2.3,0,4.1,1.8,4.1,4.1s-1.8,4.1-4.1,4.1c-2.3,0-4.1-1.8-4.1-4.1S58.3,28.1,60.6,28.1 M60.6,25.1 c-3.9,0-7.1,3.2-7.1,7.1s3.2,7.1,7.1,7.1c3.9,0,7.1-3.2,7.1-7.1S64.5,25.1,60.6,25.1L60.6,25.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M49.6,39.6c4.1,0,7.5,3.4,7.5,7.5s-3.4,7.5-7.5,7.5c-4.1,0-7.5-3.4-7.5-7.5S45.5,39.6,49.6,39.6  M49.6,36.6c-5.8,0-10.5,4.7-10.5,10.5c0,5.8,4.7,10.5,10.5,10.5s10.5-4.7,10.5-10.5C60.2,41.3,55.4,36.6,49.6,36.6L49.6,36.6z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M71.5,39.6c4.1,0,7.5,3.4,7.5,7.5s-3.4,7.5-7.5,7.5S64,51.2,64,47.1S67.3,39.6,71.5,39.6 M71.5,36.6 c-5.8,0-10.5,4.7-10.5,10.5c0,5.8,4.7,10.5,10.5,10.5S82,52.9,82,47.1C82,41.3,77.3,36.6,71.5,36.6L71.5,36.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M27.8,39.6c4.1,0,7.5,3.4,7.5,7.5s-3.4,7.5-7.5,7.5c-4.1,0-7.5-3.4-7.5-7.5S23.7,39.6,27.8,39.6  M27.8,36.6c-5.8,0-10.5,4.7-10.5,10.5c0,5.8,4.7,10.5,10.5,10.5s10.5-4.7,10.5-10.5C38.3,41.3,33.6,36.6,27.8,36.6L27.8,36.6z "
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M72.7,20.7c-46.2,0,0,0-46.2,0c-5.9,0-13.1,11.5-11.9,28.3C15.7,66.6,29.8,81,47.4,82.1 c20.4,1.3,37.3-14.9,37.3-35C84.7,32.2,77.9,20.7,72.7,20.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCrowdenergy270);
export default __webpack_public_path__ + "static/media/icons-crowdenergy-270.1f5302cd877cb70d476700f2ed4c3996.svg";
export { ForwardRef as ReactComponent };